import type { VideoConcatenatorInput } from 'web';

export function orderedVideoConcatenatorInputs(inputs: VideoConcatenatorInput[]): VideoConcatenatorInput[] {
  return [...inputs].sort((a, b) => a.order - b.order);
}
